import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const AuthDetailsAction = createAsyncThunk("authDetails",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.retrieveAuth, payload);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const AuthDetailsSlice = createSlice({
    name: "authDetails",
    initialState: {
        isLoading: false,
        data: {},
        error: null
    },
    reducers: {
        AuthDetailsReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [AuthDetailsAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [AuthDetailsAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
        },
        [AuthDetailsAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
    }
})

export const { AuthDetailsReset } = AuthDetailsSlice.actions
export default AuthDetailsSlice.reducer;